<template>
  <div id="app">
    <div class="container" v-if="pageList!=''">
      <!-- Category -->
      <div class="p-brandFilter" v-if="categoryList!=''">
        <div class="p-brandFilter__header" id="list-top">
          <p class="p-brandFilter__title">{{labels.category}}</p>
          <div class="p-brandFilter__clearButton"
               v-on:click="searchCategory(search.category)"
               >{{labels.all}}</div>
        </div>
        <ul class="p-brandFilter__items">
          <li v-for="category in categoryList" v-bind:key="category.id">
            <a
              v-on:click="searchCategory(category.id);"
              v-bind:class="['c-brandTab', 'p-brandTab--' + category.class, (search.category == category.id) ? 'is_active' : '']"
              >{{category.name}}</a>
          </li>
        </ul>
      </div>
      <!-- Contents List -->
      <div class="p-brandCard">
        <div class="p-brandCard__item" v-for="page in itemList" v-bind:key="page.nid">
          <a v-bind:href="page.alias" class="p-brandCard__body" v-bind:target="page.target ? '_blank' : false">
            <div class="p-brandCard__image">
              <img v-bind:src="page.image" v-bind:alt="page.alt">
            </div>
            <div class="p-brandCard__title" v-html="page.title"></div>
            <div class="p-brandCard__subTitle" v-html="page.text"></div>
          </a>
          <ul class="p-brandCard__footer">
            <li v-for="category in page.categories" v-bind:key="category.id">
              <a
                v-on:click="searchCategory(category.id);"
                v-bind:class="['c-brandTab', 'p-brandTab--' + category.class + 'I']"
                href="#over-category"
                >{{category.name}}</a>
            </li>
          </ul>
          <div class="p-brandCard__group">
            <span>{{page.optionalText}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="c-pagination p-pagination--brand">
      <Pager
        v-on:click="pageMove"
        v-bind:items="searchResults"
        v-bind:size="pageSize"
        v-bind:firstLastButton="true"
        v-bind:buttonLabels="pageLabels"
        anchor="#list-top"
        ></Pager>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import Pager from '../components/Pager.vue';

  const JSON_PATH = '/brand/list.json';

  export default {
    name: 'list',
    components: {
      Pager
    },
    data: function () {
      return{
        search: {
          category: null
        },
        categoryList: [],
        pageList: [],
        labels: '',

        pageLabels: {
          "first": "<<",
          "prev": "<",
          "next": ">",
          "last": ">>"
        },

        pageOffset: 0,
        pageSize: 9
      }
    },
    computed: {
      searchResults: function () {
        let list = this.pageList;
        let result = [];

        for (let i = 0; i < this.pageList.length; i++) {

          // filter category
          if (this.search.category) {
            if (list[i].categories.findIndex(({id}) => id === this.search.category) < 0) {
              continue;
            }
          }
          result.push(list[i]);
        }

        return result;
      },
      itemList: function () {
        return this.searchResults.slice(this.pageOffset, this.pageOffset + this.pageSize);
      }
    },
    methods: {
      searchCategory: function (id) {
        if (this.search.category == id) {
          this.search.category = null;
        } else {
          this.search.category = id;
        }
      },
      pageMove: function (currentPage) {
        this.pageOffset = currentPage * this.pageSize;
      }
    },
    created: function () {
      // get data
      axios.get(JSON_PATH)
              .then((response) => {
                this.categoryList = response.data.category_list;
                this.pageList = response.data.page_list;
                this.labels = response.data.labels;
              });
      // get url params
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      if (params.get('category')) {
        this.search.category = params.get('category');
      }
    }
  }
</script>
